import FeatherIcon from 'feather-icons-react';
import { formatSize } from '../../containers/documentUpload/utils';

interface FileComponentProps {
  file: File;
  valid: boolean;
  errors: string[];
  removeFile: (fileName: string) => void;
}

function FileComponent(props: FileComponentProps) {
  const { file, errors, valid, removeFile } = props;
  return (
    <div
      key={file.name}
      className={`flex items-center gap-3 p-3 rounded-xl border transition-all duration-150 ${
        valid ? 'bg-white border-stone-200' : 'bg-red-50 border-red-200'
      }`}
    >
      <FeatherIcon icon="file" className="text-gray-500" size={20} strokeWidth={1.5} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center">
          <span className="text-sm font-medium text-stone-700 truncate">{file.name}</span>
        </div>
        <p className="text-xs text-stone-400 mt-0.5">{formatSize(file.size)}</p>
        {errors.length > 0 && (
          <div className="mt-1 space-y-0.5">
            {errors.map((err, i) => (
              <p key={i} className="text-xs text-red-500">
                {err}
              </p>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={() => removeFile(file.name)}
        className="mt-1 p-2 cursor-pointer -mr-1 rounded-md text-stone-300 active:text-stone-600 active:bg-stone-100 transition-colors flex-shrink-0"
        aria-label={`Remove ${file.name}`}
      >
        <FeatherIcon icon="trash-2" className="text-negative" size={20} strokeWidth={1.5} />
      </button>
    </div>
  );
}

export default FileComponent;
